module.exports = __webpack_public_path__ + "static/logo-plus-f59b6fe50d3f485dae144983700a9180.png";